import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";

const CATEGORIES_ENDPOINT = "/category";

export class CategoryService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE CATEGORIAS
     * @EN GETS THE LIST OF CATEGORIES
     */
    // -------------------------------------------------------------------------------------------------------------
    listCategories = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: CATEGORIES_ENDPOINT + "/list",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA CATEGORIA POR SU ID
     * @EN GETS A CATEGORY BY ITS ID
     */
    // -------------------------------------------------------------------------------------------------------------
    getCategoryById = async (categoryId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: CATEGORIES_ENDPOINT + "/get",
            data: { id: categoryId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES TOGGLEA UNA CATEGORIA
     * @EN TOGGLES A CATEGORY
     */
    // -------------------------------------------------------------------------------------------------------------
    toggleCategoryStatus = async (categoryId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: CATEGORIES_ENDPOINT + "/toggle",
            data: { id: categoryId, active: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UNA CATEGORIA
     * @EN CREATES A CATEGORY
     */
    // -------------------------------------------------------------------------------------------------------------
    createCategory = async (category: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: CATEGORIES_ENDPOINT + "/create",
            data: category,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UNA CATEGORIA
     * @EN EDITS A CATEGORY
     */
    // -------------------------------------------------------------------------------------------------------------
    editCategory = async (category: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: CATEGORIES_ENDPOINT + "/edit",
            data: category,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UNA CATEGORIA
     * @EN DELETES A CATEGORY
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteCategory = async (categoryId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: CATEGORIES_ENDPOINT + "/delete",
            data: { id: categoryId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIAS CATEGORIAS
     * @EN DELETES MULTIPLE CATEGORIES
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiCategory = async (categoryIds: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: CATEGORIES_ENDPOINT + "/delete-multi",
            data: { 
                ids:categoryIds
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE CATEGORIAS PARA UN SELECT
     * @EN GETS THE LIST OF CATEGORIES FOR A SELECT   
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: CATEGORIES_ENDPOINT + "/list-select",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}